/** Settings → Account's plan block, the plan line and the trial notices. */
export default {
  pricePerMonth: "{price} a month",
  pricePerYear: "{price} a year",
  endOfPeriod: "the end of this period",
  trialDaysLeft: {
    one: "Pro trial, {count} day left",
    other: "Pro trial, {count} days left",
  },
  freeRequestsLine:
    "{used} of {limit} on-screen requests used this month. They reset on {date}.",
  freeUsageLine:
    "{projectsUsed} of {projectsLimit} projects and {appsUsed} of {appsLimit} apps in use.",
  freePlanRequests: "Free plan, {used} of {limit} requests used",
  freePlan: "Free plan",
  manageBilling: "Manage billing",
  updateCard: "Update card",
  keepProFor: "Keep Pro for {price}",
  upgradeFor: "Upgrade for {price}",
  tryProFree: "Try Pro free for 14 days",
  previewProStatement: "You’re on Pro in Preview.",
  previewProLine: "Included for verified @denker.ai accounts.",
  previewProPlanLine: "Pro in Preview",
  paymentFailedStatement: "Your payment didn’t go through.",
  paymentFailedLine: "You’re on Free until you update your card.",
  paymentFailedPlanLine: "Free, payment failed",
  pausedStatement: "Pro is paused.",
  pausedLine: "Resume it anytime in billing.",
  pausedPlanLine: "Pro paused",
  tryingProStatement: "You’re trying Pro.",
  trialUnfinishedLine:
    "Your trial is still on. Finish setting up payment to keep Pro after {date}.",
  proEndsStatement: "Pro ends on {date}.",
  cancelingLine: "After that you’re on Free. Nothing more is charged.",
  proUntil: "Pro until {date}",
  proPlan: "Pro plan",
  trialEndsThenPrice: "Your trial ends on {date}. Then {price}.",
  trialEnds: "Your trial ends on {date}.",
  trialEndsNoCharge:
    "Your trial ends on {date}. Nothing is charged automatically.",
  onProStatement: "You’re on Pro.",
  activePriceAndCharge: "{price}. Your next charge is on {date}.",
  activePrice: "{price}.",
  nextCharge: "Your next charge is on {date}.",
  onFreeStatement: "You’re on Free.",
  portalFailed: "Failed to open billing portal",
  billingNotConfigured:
    "Billing is not configured yet. Please try again later.",
  checkoutFailed: "Failed to start checkout",
  trialStartFailed: "Failed to start your trial. Please try again.",
  seeWhatProAdds: "See what Pro adds",
  aiChargesNote:
    "Your connected AI provider’s subscription or usage charges are separate.",
  benefitUnlimitedRequests:
    "Unlimited on-screen requests (reading the screen is always free)",
  benefitUnlimitedProjects: "Unlimited projects and apps",
  benefitMemory: "Knowledge graph memory across conversations",
  trialEndedTitle: "Your Pro trial has ended",
  trialEndedBody:
    "You're on Free now. Subscribe for {price}/month to keep unlimited on-screen requests, projects and integrations, plus knowledge graph memory.",
  trialEndsSoonTitle: "Your Pro trial ends soon",
  trialStartsNowTitle: "Your trial starts now",
  trialStartedTitle: "Your 14-day Pro trial has started",
  trialStartedBody:
    "Pro until {date}. No automatic charge. Continue on Free afterward, or subscribe for {price}/month to keep unlimited on-screen requests, projects and integrations.",
  viewSubscription: "View subscription",
} as const;
